import { t } from 'app/i18l'
import { AnytimeMetricsScreenProps as AnytimeCrewMetricsScreenProps } from 'home/stack/types'
import { useLayoutEffect } from 'react'
import { showHeaderTitle } from 'shared/header/header_title'
import { AnytimeCrewMetricsView } from './views'

export function AnytimeCrewMetricsScreen({
  navigation,
}: AnytimeCrewMetricsScreenProps) {
  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('anytimeMetrics'))
  }, [navigation])

  return <AnytimeCrewMetricsView />
}
